<template>
  <v-select
    v-if="!isLoading"
    v-model="clase.equipaje_personal.dimensiones"
    :items="dimensiones"
    item-text="nameUM"
    item-value="id"
    outlined
    dense
    hide-details
    :suffix="sufijo"
    disabled
    @change="changeSelect()"
  ></v-select>
</template>

<script>

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    clase: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: true,
      sufijo: null,
      dimensiones: [],
    }
  },

  created() {
    this.load()
  },
  methods: {

    load() {
      this.axios.get(`nom_dimensiones_flights?perfil_slug=${sessionStorage.getItem('perfil')}&tipo=cabina`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
        },
      })
        .then(res => {
          const result = res.data.data
          result.forEach(element => {
            if (element.tipo === 'Artículo personal') {
              this.dimensiones.push({
                id: element.id,
                nameUM: `${element.nameUM}`,
              })
            }
          })
        })
        // eslint-disable-next-line no-return-assign
        .finally(() => (this.isLoading = false))
    },
    changeSelect() {
      this.sufijo = null
      if (this.clase.equipaje_personal.dimensiones) {
        this.sufijo = this.dimensiones.filter(e => e.id === this.clase.equipaje_personal.dimensiones)[0].um
      }
    },
  },
}
</script>
